import React from 'react';
import PropTypes from 'prop-types';

const Card = ({ children, header, className }) => (
  <div className={`bvs-card ${className}`}>
    { header && <div className="bvs-card__header">{ header }</div>}
    { children }
  </div>
);

Card.propTypes = {
  header: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Card.defaultProps = {
  header: '',
  className: '',
};

export default Card;
